
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add-listing/licensing-by-aqar",
      function () {
        return require("private-next-pages/add-listing/licensing-by-aqar.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/add-listing/licensing-by-aqar"])
      });
    }
  